import axios from 'axios'

export const getPrice = () => {
    return axios.get(process.env.REACT_APP_API_URL + 'peak_defi_price');
}